// extracted by mini-css-extract-plugin
module.exports = {"cornerSprite":"style__cornerSprite__WElHF","sideSprite":"style__sideSprite__gUPGJ","middleSprite":"style__middleSprite__2LCLp"};